"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelPopover = void 0;
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var LabelHelpers_1 = require("./LabelHelpers");
var Styles_1 = require("./Styles");
var CertificationPopover_1 = require("./certification/CertificationPopover");
var SensitivityPopover_1 = require("./sensitivity/SensitivityPopover");
var WarningPopover_1 = require("./warning/WarningPopover");
var labelPlaceholder = (react_1.default.createElement("div", null,
    react_1.default.createElement(widgets_1.LoadingBone, null),
    react_1.default.createElement("div", null,
        react_1.default.createElement(widgets_1.LoadingBone, { style: { marginBottom: '1rem' } }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(widgets_1.LoadingBone, null),
            react_1.default.createElement(widgets_1.LoadingBone, null)))));
function LabelPopoverInner(props) {
    switch (props.category) {
        case 'certification': return (react_1.default.createElement(CertificationPopover_1.CertificationPopover, __assign({}, props)));
        case 'warning': return (react_1.default.createElement(WarningPopover_1.WarningPopover, __assign({}, props)));
        case 'sensitivity': return (react_1.default.createElement(SensitivityPopover_1.SensitivityLabelPopover, __assign({}, props)));
    }
}
function renderLabelPopoverLoaded(props) {
    if (!props || props.kind === 'dehydrated') {
        return react_1.default.createElement(LabelMissing, null);
    }
    return (react_1.default.createElement(LabelHelpers_1.LabelsPopoverContext.Provider, { value: (0, LabelHelpers_1.buildLabelsPopoverContext)(props) },
        react_1.default.createElement(LabelPopoverInner, __assign({}, props))));
}
function LabelMissing() {
    return (react_1.default.createElement("div", null, Localize_1.Messages.LabelRetrievalFailure()));
}
function LabelPopover(_a) {
    var resolved = _a.resolved, loading = _a.loading;
    return (react_1.default.createElement(widgets_1.SkeletonLoaderWidget, { isPending: !resolved || loading, fallback: labelPlaceholder, style: Styles_1.LabelPopoverContentStyle }, renderLabelPopoverLoaded(resolved)));
}
exports.LabelPopover = LabelPopover;
//# sourceMappingURL=LabelPopover.js.map